<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_885')}}</div>
    <div slot="body">
      <p>{{$t('scope.text_518')}}<span class="company">{{ params.data[0].name }}</span>{{$t('scope.text_886')}}</p>
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_887')" v-bind="formItemLayout">
          <a-textarea
            :placeholder="$t('scope.text_887')"
            v-decorator="decorators.memo"
            :autoSize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ProjectRefuseDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      scope: this.$store.getters.scope,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        memo: [
          'memo',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  methods: {
    doApprove (data) {
      return new this.$Manager('projectrecords').performAction({
        action: 'review',
        id: this.params.data[0].id,
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doApprove({ status: 'refused', ...values })
        this.loading = false
        this.cancelDialog()
        this.$bus.$emit('project:refuseSuccess')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "~@/styles/less/theme";

.company {
  color: @warning-color;
}
</style>
